export default "__VITE_ASSET__BBlvFKYb__"